/**
 * Aravie Custom JavaScript
 * Handles sticky nav, cart badges, toast notifications, and interactive features
 */

(function() {
  'use strict';

  // Global cart count
  let cartCount = 0;

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    initStickyNav();
    initCartBadges();
    initFAQ();
    initReviewsSlideshow();
    updateCartCount();
    interceptCartAddRequests();
  });

  /**
   * Sticky Navigation Handler
   */
  function initStickyNav() {
    const navContainer = document.querySelector('.aravie-nav-container');
    const stickyLogoMobile = document.getElementById('aravieStickyLogoMobile');

    if (!navContainer && !stickyLogoMobile) return;

    window.addEventListener('scroll', function() {
      const scrollY = window.scrollY;
      const isDesktop = window.innerWidth > 768;

      // Desktop: make entire nav sticky with background
      if (isDesktop && navContainer) {
        if (scrollY > 100) {
          navContainer.classList.add('scrolled');
        } else {
          navContainer.classList.remove('scrolled');
        }
      }

      // Mobile: show sticky logo only
      if (!isDesktop && stickyLogoMobile) {
        if (scrollY > 200) {
          stickyLogoMobile.classList.add('show');
        } else {
          stickyLogoMobile.classList.remove('show');
        }
      }
    });
  }

  /**
   * Update Cart Badges
   */
  function updateCartBadges() {
    const badges = [
      document.getElementById('aravie-desktop-cart-badge'),
      document.getElementById('aravie-hero-desktop-cart-badge'),
      document.getElementById('aravie-mobile-cart-header-badge'),
      document.getElementById('aravie-mobile-cart-bottom-badge')
    ];

    badges.forEach(badge => {
      if (badge) {
        badge.textContent = cartCount;
        if (cartCount > 0) {
          badge.classList.add('show');
        } else {
          badge.classList.remove('show');
        }
      }
    });
  }

  /**
   * Fetch current cart count from Shopify
   */
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        cartCount = data.item_count;
        updateCartBadges();
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

  /**
   * Intercept cart add requests to show product preview
   */
  function interceptCartAddRequests() {
    const originalFetch = window.fetch;

    window.fetch = function(...args) {
      const url = args[0];

      // Check if this is a cart add request
      if (typeof url === 'string' && url.includes('/cart/add')) {
        console.log('Intercepted cart add request');

        return originalFetch.apply(this, args)
          .then(response => {
            // Clone the response so we can read it
            const clonedResponse = response.clone();

            clonedResponse.json().then(data => {
              console.log('Cart add response data:', data);
              console.log('Response status:', response.status);

              // Check if the add was successful
              if (response.ok && response.status === 200) {
                // Update cart count after successful add
                updateCartCount();

                // Show success toast with product preview
                if (data) {
                  const formattedPrice = data.price ? `$${(data.price / 100).toFixed(2)}` : '';
                  let productImage = data.image;
                  if (data.featured_image) {
                    productImage = data.featured_image.url || data.featured_image;
                  }

                  showToast({
                    message: 'Added to cart!',
                    productName: data.product_title || data.title,
                    productImage: productImage,
                    productPrice: formattedPrice
                  });
                }
              } else {
                // Show error message
                const errorMessage = data.description || data.message || 'Could not add item to cart';
                showToast({
                  message: errorMessage,
                  isError: true
                });
              }
            }).catch(err => {
              console.error('Error parsing cart add response:', err);
            });

            return response;
          });
      }

      return originalFetch.apply(this, args);
    };
  }

  /**
   * Subscribe to Shopify Cart Events
   */
  function subscribeToShopifyCartEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.warn('Shopify PubSub system not available');
      return null;
    }

    return subscribe(PUB_SUB_EVENTS.cartUpdate, function(event) {
      console.log('Cart update event received:', event);

      if (event && event.cartData) {
        cartCount = event.cartData.item_count;
        updateCartBadges();
      } else {
        updateCartCount();
      }
    });
  }

  /**
   * Initialize Cart Badges
   */
  function initCartBadges() {
    updateCartCount();

    // Subscribe to Shopify's global cart events
    subscribeToShopifyCartEvents();

    // Listen for custom cart updates (backward compatibility)
    document.addEventListener('cart:updated', function() {
      updateCartCount();
    });
  }

  /**
   * Show Toast Notification
   * @param {string|object} options - Either a simple message string or an object with product details
   * @param {string} options.message - The message to display
   * @param {string} options.productName - Product name
   * @param {string} options.productImage - Product image URL
   * @param {string} options.productPrice - Product price (formatted)
   * @param {boolean} options.isError - Whether this is an error message
   */
  function showToast(options) {
    console.log('showToast called with:', options);

    const toast = document.getElementById('aravie-toast');
    const toastMessage = document.getElementById('aravie-toast-message');
    const toastTitle = document.getElementById('aravie-toast-title');
    const toastSubtitle = document.getElementById('aravie-toast-subtitle');
    const toastImage = document.getElementById('aravie-toast-image');
    const toastIcon = document.querySelector('.aravie-toast-icon');

    console.log('Toast elements:', { toast, toastMessage, toastTitle, toastSubtitle, toastImage });

    if (!toast) {
      console.error('Toast element not found!');
      return;
    }

    // Handle simple string message (backward compatibility)
    if (typeof options === 'string') {
      toastMessage.textContent = options;
      toast.classList.remove('has-image');
      toast.classList.add('simple', 'show');

      // Set icon to checkmark for simple messages (assuming success)
      if (toastIcon) {
        toastIcon.className = 'fas fa-check-circle aravie-toast-icon';
      }

      setTimeout(() => {
        toast.classList.remove('show');
      }, 3000);
      return;
    }

    // Update icon based on success/error
    if (toastIcon) {
      if (options.isError) {
        toastIcon.className = 'fas fa-exclamation-circle aravie-toast-icon aravie-toast-icon-error';
      } else {
        toastIcon.className = 'fas fa-check-circle aravie-toast-icon';
      }
    }

    // Handle product preview
    if (options.productImage && options.productName) {
      toast.classList.remove('simple');
      toast.classList.add('has-image');

      if (toastImage) {
        toastImage.src = options.productImage;
        toastImage.alt = options.productName;
      }

      if (toastTitle) {
        toastTitle.textContent = options.productName;
      }

      if (toastSubtitle && options.productPrice) {
        toastSubtitle.textContent = options.productPrice;
      }

      if (toastMessage) {
        toastMessage.textContent = options.message || 'Added to cart!';
      }
    } else {
      // Simple message (error or basic notification)
      toast.classList.remove('has-image');
      toast.classList.add('simple');
      if (toastMessage) {
        toastMessage.textContent = options.message;
      }
    }

    toast.classList.add('show');

    setTimeout(() => {
      toast.classList.remove('show');
    }, 3500);
  }

  /**
   * Quick Add to Cart
   */
  window.aravieQuickAddToCart = function(event, variantId, productName) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.target.closest('button');
    if (!button) return;

    // Show loading state
    const originalHTML = button.innerHTML;
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Adding...';
    button.disabled = true;

    // Add to cart via Shopify Ajax API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Debug: Log the response
      console.log('Cart add response:', data);

      // Update cart count
      cartCount++;
      updateCartBadges();

      // Show success state
      button.innerHTML = '<i class="fas fa-check"></i> Added!';
      button.style.background = '#4CAF50';

      // Format price (Shopify returns price in cents)
      const formattedPrice = data.price ? `$${(data.price / 100).toFixed(2)}` : '';

      // Get product image (handle optional chaining for older browsers)
      let productImage = data.image;
      if (data.featured_image) {
        productImage = data.featured_image.url || data.featured_image;
      }

      console.log('Toast data:', {
        productName: data.product_title || productName,
        productImage: productImage,
        productPrice: formattedPrice
      });

      // Show toast with product preview
      showToast({
        message: 'Added to cart!',
        productName: data.product_title || productName,
        productImage: productImage,
        productPrice: formattedPrice
      });

      // Trigger cart drawer if available
      if (typeof window.theme !== 'undefined' && window.theme.openCart) {
        window.theme.openCart();
      }

      // Reset button after delay
      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.style.background = '';
        button.disabled = false;
      }, 1500);

      // Dispatch custom event
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.innerHTML = '<i class="fas fa-exclamation"></i> Error';
      button.style.background = '#f44336';

      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.style.background = '';
        button.disabled = false;
      }, 2000);
    });
  };

  /**
   * FAQ Accordion Toggle
   */
  function initFAQ() {
    // Select both old and new FAQ class names
    const faqItems = document.querySelectorAll('.faq-item, .aravie-faq-item');

    faqItems.forEach(item => {
      item.addEventListener('click', function(e) {
        const answer = this.querySelector('.faq-answer, .aravie-faq-answer');
        const icon = this.querySelector('.faq-icon, .aravie-faq-icon');

        // Close other FAQ items
        faqItems.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
            const otherAnswer = otherItem.querySelector('.faq-answer, .aravie-faq-answer');
            const otherIcon = otherItem.querySelector('.faq-icon, .aravie-faq-icon');
            if (otherAnswer) otherAnswer.classList.remove('active');
            if (otherIcon) otherIcon.textContent = '+';
          }
        });

        // Toggle current item
        this.classList.toggle('active');
        if (answer) answer.classList.toggle('active');
        if (icon) {
          const isActive = answer && answer.classList.contains('active');
          icon.textContent = isActive ? '−' : '+';
        }
      });
    });

    console.log('FAQ initialized:', faqItems.length, 'items found');
  }

  /**
   * Reviews Slideshow
   */
  function initReviewsSlideshow() {
    let slideIndex = 1;
    const slides = document.querySelectorAll('.review-slide');
    const dots = document.querySelectorAll('.slideshow-dot');
    const prevBtn = document.querySelector('.slideshow-arrow:first-child');
    const nextBtn = document.querySelector('.slideshow-arrow:last-child');

    if (slides.length === 0) return;

    function showSlides(n) {
      if (n > slides.length) slideIndex = 1;
      if (n < 1) slideIndex = slides.length;

      slides.forEach(slide => slide.classList.remove('active'));
      dots.forEach(dot => dot.classList.remove('active'));

      if (slides[slideIndex - 1]) slides[slideIndex - 1].classList.add('active');
      if (dots[slideIndex - 1]) dots[slideIndex - 1].classList.add('active');
    }

    function changeSlide(n) {
      showSlides(slideIndex += n);
    }

    function currentSlide(n) {
      showSlides(slideIndex = n);
    }

    // Initialize
    showSlides(slideIndex);

    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', () => changeSlide(-1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => changeSlide(1));
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => currentSlide(index + 1));
    });

    // Auto-advance every 5 seconds
    setInterval(() => changeSlide(1), 5000);
  }

  /**
   * Color Variant Switching
   */
  window.aravieSwitchVariant = function(event, productId, variant) {
    event.preventDefault();
    event.stopPropagation();

    const productContainer = document.querySelector(`[data-product="${productId}"]`);
    if (!productContainer) return;

    // Update swatch active states
    const swatches = productContainer.parentElement.parentElement.querySelectorAll('.color-swatch');
    swatches.forEach(swatch => swatch.classList.remove('active'));
    event.target.classList.add('active');

    // Hide all images for this product
    const allImages = productContainer.querySelectorAll('.product-image');
    allImages.forEach(img => img.style.opacity = '0');

    // Show images for selected variant
    const variantImages = productContainer.querySelectorAll(`[data-variant="${variant}"]`);
    variantImages.forEach(img => {
      img.style.opacity = img.classList.contains('primary') ? '1' : '0';
    });

    // Update quick add button variant
    const quickAddBtn = productContainer.closest('.product-card').querySelector('.quick-add-btn');
    if (quickAddBtn) {
      quickAddBtn.dataset.variant = variant;
    }
  };

  // Expose to global scope
  window.aravie = {
    showToast: showToast,
    updateCartCount: updateCartCount,
    quickAddToCart: window.aravieQuickAddToCart,
    switchVariant: window.aravieSwitchVariant
  };

})();
